import { getSocialSecurityArrear } from 'lib/api/business';
import SocialSecurityArrearTable from 'lib/common/Tables/SocialSecurityArrearTable';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import HeaderWithActions from 'lib/designSystem/HeaderWithActions';
import React from 'react';
import { useDispatch } from 'react-redux';

type SocialSecurityArrearTabProps = {
  identifier?: string;
};

function SocialSecurityArrearTab({ identifier }: SocialSecurityArrearTabProps) {
  if (!identifier) return;
  const dispatch = useDispatch();
  const { data: arrears, isPending: loading } = getSocialSecurityArrear(
    dispatch,
    identifier,
  );
  if (loading) return <CenteredCircularProgress relative />;

  return (
    <div>
      <HeaderWithActions variant="h6" subHeader buttons={[]} title="" />
      <SocialSecurityArrearTable arrears={arrears ?? []} />
    </div>
  );
}

export default SocialSecurityArrearTab;
